document.addEventListener("BSS:changeVariantQV", e => {
  document
  .querySelectorAll('[bss-b2b-variant-price][style="visibility: visible;"]')
  .forEach(el => {
      el.style.visibility = "hidden";
  });
  setTimeout(() => {
    const productForms = document.querySelectorAll("[bss-b2b-product-form='main']");
    productForms.forEach((p) => {
        BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', { p });;
    });
    
    setTimeout(() => {
        const productForm = document.querySelector(".product__info-wrapper [bss-b2b-product-form='main']");
        BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', { productForm });
    }, 500);
  }, 500);
});